
// @ngInject

Models.SearchablesCollection = function SearchablesCollection(BaseCollection) {

    return Class(BaseCollection, {

            constructor: function constructor(){
                this.constructor.$super.call(this);
                this._collection.__className = 'SearchablesCollection';
                this._collection.__childsType = 'SearchableModel';
                return this._collection;
            }
        }
    );
};
